const uiTheme = {
  colors: {
    light: {
      brand: {
        primary: '#D80073',
        primaryAlt: '#A60058',
        secondary: '#FFE5F3',
        secondaryAlt: '#FFA3D4',
        overPrimary: '#FFFFFF',
      },
      info: {
        primary: '#2F2EE6',
        primaryAlt: '#0100B2',
        secondary: '#D6E4FF',
        secondaryAlt: '#B2CDFF',
        overPrimary: '#FFFFFF',
      },
      alert: {
        primary: '#F67701',
        primaryAlt: '#B74A01',
        secondary: '#FFF1E0',
        secondaryAlt: '#FFD8B2',
        overPrimary: '#FFFFFF',
      },
      positive: {
        primary: '#45B12E',
        primaryAlt: '#005C00',
        secondary: '#E5FFE5',
        secondaryAlt: '#C3FAB8',
        overPrimary: '#FFFFFF',
      },
      negative: {
        primary: '#E2001B',
        primaryAlt: '#B00015',
        secondary: '#FFE8E5',
        secondaryAlt: '#FF99A5',
        overPrimary: '#FFFFFF',
      },
      neutral: {
        primary: '#1A1A1A',
        primaryAlt: '#2B2B2B',
        secondary: '#F5F5F5',
        secondaryAlt: '#DEDEDE',
        overPrimary: '#FFFFFF',
      },
      element: {
        primary: '#1A1A1A',
        secondary: '#666666',
        placeholder: '#9A9A9A',
        disabled: '#CFCFCF',
        disabledBackground: '#ECECEC',
        invert: '#FFFFFF',
        onSuccess: '#005C00',
        onError: '#B00015',
        overImage: '#1A1A1A',
        overHeader: '#FFFFFF',
      },
      background: {
        primary: '#FFFFFF',
        secondary: '#F5F5F5',
        tertiary: '#ECECEC',
        quartenary: '#1A1A1A',
        navbar: '#F5F5F5CC',
        transparent: 'transparent',
      },
      divider: {
        primary: '#00000033',
        secondary: '#1A1A1A',
        brand: '#D80073',
        positive: '#005C00',
        negative: '#B00015',
        alert: '#B74A01',
        info: '#0100B2',
        invert: '#FFFFFF33',
      },
      state: {
        hover: '#4C4C4C14',
        active: '#4C4C4C29',
        overlay: '#1A1A1AA3',
        imageOverlay: '#1A1A1A29',
      },
    },
    dark: {
      // Paleta dark suave (low-contrast, dessaturada) — evita branco puro,
      // preto puro e accents vibrantes para reduzir cansaço visual.
      brand: {
        primary: '#E07BB0',
        primaryAlt: '#EFA8CD',
        secondary: '#5C2E45',
        secondaryAlt: '#7A3E5C',
        overPrimary: '#1E1E1E',
      },
      info: {
        primary: '#5FA3D6',
        primaryAlt: '#8FC0E3',
        secondary: '#1E3A52',
        secondaryAlt: '#2C4F6B',
        overPrimary: '#1E1E1E',
      },
      alert: {
        primary: '#D69B52',
        primaryAlt: '#E3BC8C',
        secondary: '#4A3823',
        secondaryAlt: '#5C4730',
        overPrimary: '#1E1E1E',
      },
      positive: {
        primary: '#74B86B',
        primaryAlt: '#A3D69C',
        secondary: '#283D20',
        secondaryAlt: '#374F2E',
        overPrimary: '#1E1E1E',
      },
      negative: {
        primary: '#D67B82',
        primaryAlt: '#E5A8AD',
        secondary: '#522B2E',
        secondaryAlt: '#6B393C',
        overPrimary: '#1E1E1E',
      },
      neutral: {
        primary: '#D4D4D4',
        primaryAlt: '#B0B0B0',
        secondary: '#1F1F1F',
        secondaryAlt: '#2E2E2E',
        overPrimary: '#1E1E1E',
      },
      element: {
        primary: '#D4D4D4',
        secondary: '#9E9E9E',
        placeholder: '#8C8C8C',
        disabled: '#5A5A5A',
        disabledBackground: '#2E2E2E',
        invert: '#1E1E1E',
        onSuccess: '#A3D69C',
        onError: '#E5A8AD',
        overImage: '#1A1A1A',
        overHeader: '#D4D4D4',
      },
      background: {
        primary: '#2B2B2B',
        secondary: '#1F1F1F',
        tertiary: '#151515',
        quartenary: '#1A1A1A',
        navbar: '#1F1F1FE0',
        transparent: '#FFFFFF03',
      },
      divider: {
        primary: '#FFFFFF1F',
        secondary: '#3A3A3A',
        brand: '#E07BB0',
        positive: '#74B86B',
        negative: '#D67B82',
        alert: '#D69B52',
        info: '#5FA3D6',
        invert: '#00000033',
      },
      state: {
        hover: '#FFFFFF0A',
        active: '#FFFFFF14',
        overlay: '#000000A3',
        imageOverlay: '#00000029',
      },
    },
  },
  spacing: {
    '75': 2,
    '150': 4,
    '300': 8,
    '350': 12,
    '400': 16,
    '450': 20,
    '500': 24,
    '600': 32,
    '700': 40,
    '800': 48,
    '900': 56,
    '1000': 64,
    '1100': 72,
    '1200': 80,
    '1300': 88,
    '1400': 96,
    '1800': 128,
  },
  typography: {
    fontWeight: {
      bold: '700',
      semibold: '600',
      regular: '400',
    },
    heading: {
      fontFamily: 'Montserrat',
      h1: {
        fontSize: 48,
        lineHeight: 72,
      },
      h2: {
        fontSize: 40,
        lineHeight: 64,
      },
      h3: {
        fontSize: 32,
        lineHeight: 48,
      },
      h4: {
        fontSize: 24,
        lineHeight: 40,
      },
      h5: {
        fontSize: 20,
        lineHeight: 32,
      },
      h6: {
        fontSize: 18,
        lineHeight: 24,
      },
    },
    body: {
      fontFamily: 'Open Sans',
      lg: {
        fontSize: 18,
        lineHeight: 28,
      },
      md: {
        fontSize: 16,
        lineHeight: 24,
      },
      sm: {
        fontSize: 14,
        lineHeight: 20,
      },
      xs: {
        fontSize: 12,
        lineHeight: 18,
      },
    },
  },
  radius: {
    '0': 0,
    '200': 4,
    '300': 8,
    '400': 12,
    '500': 16,
    '600': '50%',
  },
};

export default uiTheme;
